import { colors } from '@cabonline/ui-shared';
import { LinkButton } from '@cabonline/ui-web';
import { InfoOutlined, MenuBookOutlined } from '@mui/icons-material';
import { useLocale } from '@multiplatform-apps/service-trips';
import { FC, useCallback } from 'react';

import { paths } from '../../../constants';
import { useModal } from '../../../context';
import { COOKIE_CONSENT_MODAL } from '../../cookie-consent';
import { MenuLink } from './menu-link';

interface MenuFooterProps {
  closeMenu: () => void;
}

export const MenuFooter: FC<MenuFooterProps> = ({ closeMenu }) => {
  const { t } = useLocale();
  const { setModalOpen } = useModal();

  const handleCookieSettings = useCallback(() => {
    setModalOpen(COOKIE_CONSENT_MODAL);
  }, [setModalOpen]);

  return (
    <>
      <MenuLink
        to={paths.manuals.root}
        label={t('navBar.manuals')}
        icon={<MenuBookOutlined htmlColor={colors.black} />}
        onClick={closeMenu}
      />
      <MenuLink
        to={paths.about.root}
        label={t('navBar.about')}
        icon={<InfoOutlined htmlColor={colors.black} />}
        onClick={closeMenu}
      />
      <LinkButton
        onClick={handleCookieSettings}
        label={t('cookieConsent.cookieSettingsButton')}
      />
    </>
  );
};
